import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div data-testid="protected-loading" className="min-h-[60vh] flex items-center justify-center">
        <div className="font-mono text-xs tracking-widest text-zinc-500">CHECKING SESSION…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  }
  return children;
}
